"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Logo;
var _logoBlue = _interopRequireDefault(require("../../assets/logoBlue.png"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Logo() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    src: _logoBlue.default,
    alt: "marty-logo",
    style: {
      maxWidth: "20vw",
      maxHeight: "20vh"
    }
  });
}